export default {
  // General
  'rt-previous-page': 'Previous',
  'rt-next-page': 'Next',
  'rt-loadingText': 'Loading',
  'rt-noDataText': 'No rows found',
  'rt-pageText': 'Page',
  'rt-ofText': 'of',
  'rt-rowsText': 'rows',
  'sms-verify':
    'Please verify your phone number with the verification sms we sent you. If you cannot receive the sms, please click the below button to resend',
  'email-verify-1':
    'Please verify your email address with the email we sent you. It may be in your Spam/Bulk/Junk folder.',
  'email-verify-2':
    'If the confirmation email ended up in your Spam/Bulk/Junk folder, please add the email address admin@datalouder.com to your Contacts list, so that future emails from us come to your Inbox. You can also contact us by emailing admin@datalouder.com to verify your email address.',
  'sms-verify-button': 'Resend Verification Sms',
  'email-verify-button': 'Resend Verification Email',
  'sms-verify-resent': 'We just resent another verification sms to you.',
  'email-verify-resent': 'We just resent another verification email to you.',
  Ok: 'Ok',
  'something-wrong':
    'Sorry, something went wrong here. Please try again later.',
  Export: 'Export',
  'wrong-password': 'Wrong Password.',
  'too-many-attempts': 'Too many attempts, please try again later.',
  'invalid-user': 'User does not exist.',
  'no-google-translate':
    'Google translation may effect the normal function of our website, please consider our EN/中 function on the upper right corner.',
  // Profile page
  'Update profile successful': '資料更新成功',
  // Payment ThankYou page
  'Thanks for subscribing Datalouder': 'Thanks for subscribing Datalouder!',
  'thankyou-page-redirect':
    'If the browser does not redirect you in 10 seconds, please click this ',
  'thankyou-page-link': 'link',
  // Nav bar
  Home: 'Home',
  Welcome: 'Welcome',
  'DataLouder.com': 'DataLouder',
  DataLouder: 'DataLouder數據說話',
  Signals: 'Signals',
  Strategy: 'Strategy',
  Ranking: 'Ranking',
  Search: 'Search',
  Lookup: 'Lookup',
  Tips: 'Tips',
  'Tips List': 'Tips List',
  'Stock Ranking': 'Stock Ranking',
  'Influencer Ranking': 'Influencer Ranking',
  'Participant Ranking': 'Participant Ranking',
  'My Account': 'Me',
  Profile: 'Profile',
  'Membership & Payment': 'Membership & Payment',
  'Log out': 'Log out',
  Register: 'Register',
  'Verify Login': 'Verify Login',
  Login: 'Login',
  Statistics: 'Statistics',
  'US Statistics': 'US Statistics',
  'HK Statistics': 'HK Statistics',
  'US Signals': 'US Signals',
  'HK Signals': 'HK Signals',
  'font-small': 'A',
  'font-large': 'A',
  'hk-stock': 'HK',
  'us-stock': 'US',
  // updater
  'New version available': 'New version available',
  'new version p 1':
    'We continuous to improve your experience by regularly release new versions.',
  'new version p 2':
    'Your Datalouder client is out of date, please update to the latest version to continue.',
  Update: 'Update',
  Status: 'System Status',
  // signals
  'Select Signal': 'Select Signal',
  'Inverted Hammer': 'Inverted Hammer',
  'Evening Star': 'Evening Star',
  'Bullish Engulfing': 'Bullish Engulfing',
  'Bearish Engulfing': 'Bearish Engulfing',
  'Rising Sun': 'Rising Sun',
  'Dark Cloud Cover': 'Dark Cloud Cover',
  'Bullish Two Day Reversal': 'Bullish Two Day Reversal',
  'Bearish Two Day Reversal': 'Bearish Two Day Reversal',
  'Three White Soldiers': 'Three White Soldiers',
  'Three Dark Crows': 'Three Dark Crows',
  'Morning Star': 'Morning Star',
  Hammer: 'Hammer',
  'Black Candle': 'Black Candle',
  'White Candle': 'White Candle',
  Viewer: 'Viewer',
  Occurences: 'Occurences',
  signalOccurred: 'Same signal occurred',
  Probability: 'Probability',
  'signal-click-to-view': 'Click a data point to display occurence details.',
  '-': '-',
  bodyRelative: 'Body length (relative)',
  'upperShadow / body': 'Upper shadow / body',
  'lowerShadow / body': 'Lower shadow / body',
  'lowerShadow / open': 'Lower shadow / open',
  'lowerShadow / wick': 'Lower shadow / wick',
  'upperShadow / open': 'Upper shadow / open',
  'upperShadow / wick': 'Upper shadow / wick',
  bodyRelativeBe1D: 'Body length yesterday (relative)',
  bodyRelativeBe2D: 'Body length two days ago (relative)',
  'wickBe1D / openBe1D': 'Wick length (yesterday) / open price (yesterday)',
  // group
  'Group By': 'Group By',
  All: 'All',
  Combined: 'Combined',
  Deviation: 'Deviation',
  'Relative Price (6 months)': 'Relative Price (6M)',
  'Relative Price (12 months)': 'Relative Price (12M)',
  Bluestacks: 'Bluestacks',
  'Market Cap': 'Market Cap',
  BollingerBand: 'BollingerBand',
  'Relative Strength Index': 'Relative Strength Index',
  'Moving Average': 'Moving Average',
  'View group': 'View group',
  'Any value': 'Any value',
  '&&': 'and',
  'lowest quarter': 'lowest quarter',
  'lower quarter': 'lower quarter',
  'upper quarter': 'upper quarter',
  'highest quarter': 'highest quarter',
  '<1T': '<1T',
  '1T-5T': '1T-5T',
  '5T-30T': '5T-30T',
  '>30T': '>30T',
  Bluestack: 'Bluestack',
  'Bluestack-short': 'BS',
  Others: 'Others',
  // Occurence tab
  'Please select a signal.': 'Please select a signal.',
  'No data available': 'Sorry No data avilable',
  // Prob tab
  Day: 'Day',
  'Day (solid)': 'Baseline 1 (Days Ago, Solid)',
  'Day (dashed)': 'Baseline 2 (Days Ago, Dashed)',
  dashed: 'Solid',
  solid: 'Dashed',
  'smooth-select': 'Data',
  'Smooth-cma': 'Smooth (CMA)',
  'Smooth-sma': 'Smooth (SMA)',
  'Smooth-raw': 'Raw',
  smooth: 'smooth',
  raw: 'Raw',
  // Signal occurence table
  'Stock Code': 'Stock Code',
  High: 'High',
  Low: 'Low',
  Open: 'Open',
  Close: 'Close',
  'close-or-now': 'Close or Current Price',
  Volume: 'Volume',
  // Zone
  'Stock Name': 'Stock Name',
  // Ranking
  'current-category': 'Current category',
  'all-categories': 'All categories',
  'stock-gain-loss': 'Stocks',
  'industry-gain-loss': 'Industries',
  Mainboard: 'Mainboard',
  Gem: 'Gem',
  'Updated on': 'Updated on',
  Price: 'Price',
  Change: 'Change',
  '% Change': '% Change',
  'Vol. / Avg ()': 'Vol. / Avg (%s)',
  Turnover: 'Turnover',
  Mktcap: 'Mktcap',
  Concentration: 'Concentration',
  'Price Range': 'Price Range',
  'Price Range Filter': 'Price Range Filter',
  '* All CCASS data is 3 trading days old.':
    '* All CCASS data is 3 trading days old.',
  'Updated at': 'Updated at',
  'showing data of %s': 'showing data of %s',
  '1d': '1d',
  '3d': '3d',
  '5d': '5d',
  '1m': '1m',
  '2m': '2m',
  '3m': '3m',
  '6m': '6m',
  '1y': '1y',
  '52w': '52w',
  Vol: 'Vol',
  Gain: 'Gain',
  Loss: 'Loss',
  'last-transaction-time': 'Last transaction time',
  'show-category-label-btn': 'Show All Categories',
  'reset-btn': 'Reset',
  'one-month-data-available': 'Data for the past month is available',
  // price viewer
  noDataFetched: 'No Data',
  nopDescription1: 'Blue line',
  nopDescription2: '：NOP, number of retail investors',
  concentrationDescription1: 'Green line',
  concentrationDescription2:
    '：Concentration, Shares holding by top institutional investors',
  cryptoDescription: 'All Crypto is in USD',
  descriptionMore: 'More',
  'Overlap volume with price': 'Overlap volume with price',
  'Overlap turnover with price': 'Overlap turnover with price',
  nop1: 'NOP',
  nop2: 'NOP(T+2)',
  'Bollinger Band': 'Bollinger Band',
  'fear-greed-index': 'Fear & Greed Index',
  southbound: 'Southbound',
  'aaii-bullish': 'Bullish',
  'aaii-bearish': 'Bearish',
  AAII: 'AAII Index',
  Fundamental: 'Fundamental',
  PE: 'PE Ratio',
  PB: 'PB Ratio',
  'dividend-yield': 'Dividend Yield',
  'short-ratio': 'Short Ratio',
  MACD: 'MACD',
  RSI: 'RSI',
  'retail-trades': 'Retail Trades',
  'institutional-trades': 'Institutional Trades',
  'nop-strategy': 'NOP Strategy',
  'strategy-return': 'Strategy Return',
  'strategy-signal': 'Strategy Signal',
  'buy-signal': 'Buy Signal',
  'sell-signal': 'Sell Signal',
  'flat-long-position': 'Flat Long Position',
  'close-position': 'Close Position',
  bid: 'Sell',
  ask: 'Buy',
  IndexSMA: 'IndexSMA',
  MarketSMA: 'MarketSMA',
  opinion: 'Opinion',
  'expert-bullish': ' felt bullish on this day',
  'expert-bearish': ' felt bearish on this day',
  'felt-bullish': 'You felt bullish on this day',
  'felt-bearish': 'You felt bearish on this day',
  'not-felt-bullish': 'You were no longer felt bullish on this day',
  'not-felt-bearish': 'You were no longer felt bearish on this day',
  d: 'd',
  'No historical prices available': 'No historical prices available',
  'The nearest (before) available summary is available on': '最近更新數據於',
  'symbol-period': '.',
  'No data is found.': 'No data is found.',
  high: 'High',
  low: 'Low',
  open: 'Open',
  close: 'Close',
  volume: 'Volume',
  amplitude: 'Amplitude',
  max: 'Max',
  'unit-minute': 'Min',
  'unit-d': '1D',
  'unit-w': '1W',
  'unit-m': '1M',
  'minute-unit-1m': '1M',
  'minute-unit-3m': '3M',
  'minute-unit-5m': '5M',
  'minute-unit-15m': '15M',
  'minute-unit-1h': '1H',
  'minute-update-explain':
    'Minute tick data is updated after trading hours of each day',
  'nop-explain':
    'CCASS+ participants number on the trading day, NOP(T+2) shows the release day)',
  tags: 'Tags',
  'shift-to-zoom-tip': '<bold>Zoom in/out</bold> | Hold "shift" key and scroll',
  // CCASS
  Shareholding: 'Shareholding',
  'Shareholding Date': 'Shareholding Date',
  Summary: 'Summary',
  'Shareholding in CCASS': 'Shareholding',
  'Number of Participants': 'Number of Participants',
  '% of the total number of Issued Shares/ Warrants/ Units':
    '% of Issued Shares',
  'Market Intermediaries': 'Market Intermediaries',
  'Consenting Investor Participants': 'Consenting Investor Participants',
  'Non-consenting Investor Participants':
    'Non-consenting Investor Participants',
  'Total CCASS': 'Total CCASS',
  'Securities not in CCASS': 'Securities not in CCASS',
  'Total number of Issued Shares/Warrants/Units':
    'Total number of Issued Shares/Warrants/Units',
  '(last updated figure)': '(last updated figure)',
  'N Change %': 'Participant Number Change',
  'N Level': 'Participant Number',
  'N Level Filter': 'Participant Number Filter',
  'Concentration Level': 'Concentration Level',
  'Top N Concentration': 'Top N Concentration',
  'Top N Concentration Change': 'Top N Concentration Change',
  'Weighted Top N Concentration Change': 'Weighted Top N Concentration Change',
  'Compare Date': 'Comparing Date',
  'Days Before': 'Days Before',
  Customize: 'Customize',
  'compared to': 'Compared to',
  'previous-day': 'the previous day',
  'Details of Market Intermediaries/Consenting Investor Participants':
    'Details of Market Intermediaries/Consenting Investor Participants',
  Remarks: 'Remarks',
  'view-full-page': 'View the full page',
  'ccass-remark-1':
    "Market Intermediaries include CCASS Participants other than Investor Participants. Negative shareholding may be occurred for individual Market Intermediaries due to special circumstances. For example, it may due to incorrect signatures being found on the share certificates deposited by a Market Intermediary upon sending for re-registration. The CCASS account of the Market Intermediary will be debited for the share quantity in question until rectification. During this period, which may take a few days, the Market Intermediary's account may show a negative shareholding.",
  'ccass-remark-2':
    'Non-consenting Investor Participants are those Investor Participants who do not wish to disclose their shareholding.',
  'ccass-remark-3':
    'Consenting Investor Participants are those Investor Participants who wish to disclose their shareholding.',
  'ccass-remark-4':
    'Shareholding details of the security with multi-counters will be shown at per counter basis while total numbers of issued shares/ warrants / units of the security for each counter are total numbers of issued shares/ warrants / units of the security of all counters. The percentages of issued shares/ warrants/ units of each counter are calculated based on the total numbers of issued shares/ warrants/ units of all counters.',
  'ccass-remark-5':
    'The total number of issued shares / warrants / units of the relevant securities / units used for calculating the percentage of shareholding may not have taken into account any change in connection with or as a result of any corporate actions of the relevant securities or the creation and redemption of units and hence, may not be up-to-date. The percentage of shareholding is for reference only. Percentage of individual Participant may not add up to the percentage of its sub-group total and total CCASS shareholding due to rounding. Please exercise caution when using the percentage presented in the CCASS Shareholding Search.',
  '% Share': '% Share',
  'Share Change': 'Share Change',
  'avg buy': 'Avg Buying Price',
  'avg sell': 'Avg Selling Price',
  'avg trade': 'Avg Trading Price',
  'total change amount': 'Total Change Amount',
  'total change amount by day': 'Days total change amount',
  'Name of CCASS Participant': 'Name of CCASS Participant',
  'Share Holding Level': 'Share Holding (52w)',
  'Participant ID': 'Participant ID',
  'Holding Change': 'Holding Change',
  'Diff/Shares': 'Diff/Shares',
  Table: 'Table',
  'other-participants': 'Other participants',
  'sharehold-distribution': 'Shareholding Distribution',
  'buy-in-ranking': 'Top Buy-ins',
  'sell-out-ranking': 'Top Sell-outs',
  // My Account
  'Basic Information': 'Basic Information',
  'Your name': 'Your name',
  'Your public name': 'Your Public Username',
  'Email address or phone number': 'Email address or Phone number',
  'Login placeholder': 'e.g. lewis@datalouder.com or +85269000755',
  Password: 'Password',
  'Retype Password': 'Retype Password',
  // Footer
  Version: 'Version',
  'Contact Us': 'Contact Us',
  'Term of Service': 'Term of Service',
  Disclaimer: 'Disclaimer',
  Copyright: 'Copyright',
  'Privacy Policy': 'Privacy Policy',
  // Payment
  'No record.': 'No record.',
  Date: 'Date',
  Amount: 'Amount',
  Detail: 'Detail',
  Verified: 'Verified',
  Received: 'Received',
  Pending: 'Pending',
  Transactions: 'Transactions',
  'almost-join-us': 'Upgrade to Pro plan to unlock full DataLouder experience.',
  'promo-free-month':
    'You will get your first month free if you join us right now.',
  'payment-success':
    'We are verifying and updating the subscription, and you can refresh this page to check your membership status. This page will refresh itself in 60 seconds.',
  'membership-remain': 'Thanks for joining us! Your membership will expire in',
  'avg-day-payment': 'Average daily spending is HKD',
  'charge-time-for-free-trial':
    "You won't be charged until the 10-day free trial ends.",
  days: 'days',
  Membership: 'Membership',
  Item: 'Item',
  Number: 'Number',
  'Free Month Bonus': 'Free Month Bonus',
  'Equal to': 'Equal to',
  Total: 'Total',
  '/ Month': '/ Month',
  discount: 'discount',
  'renew-it': 'Extend My Membership',
  'select-renew-options': 'Please select a renew option:',
  paypal: 'PayPal',
  'paypal-subscription': 'Subscription',
  'other-payment-methods': 'Other payment methods',
  'recurring-payment':
    'This is a recurring payment. When your membership expires, we will charge you the same amount of fee unless being cancelled.',
  'promo-code': 'Promo Code:',
  apply: 'Apply',
  'have-applied': 'You have applied promotion "{{title}}."',
  'invalid-promo': 'The promo code "{{code}}" is invalid.',
  Promo: 'Promo',
  'may-be-delayed': 'the information may be delayed',
  'cannot-find-subscription': 'Cannot find any subscriptions',
  'subscription-status': 'Subscription Status',
  'subscription-status-ACTIVE': 'Active',
  'subscription-status-SUSPENDED': 'Auto-Billing Paused',
  'subscription-status-APPROVAL_PENDING': 'Pending Approval',
  'subscription-status-CANCELLED': 'Cancelled',
  'subscription-status-CANCELED': 'Cancelled', // stripe only
  'subscription-status-TRIALING': 'Active', // stripe only, text same as "active" due to subscription extension has trialing status
  'subscription-status-PAST_DUE': 'Past Due', // stripe only
  'subscription-status-UNPAID': 'Unpaid', // stripe only
  'subscription-status-INCOMPLETE': 'Incomplete', // stripe only
  'subscription-status-INCOMPLETE_EXPIRED': 'Incomplete Expired', // stripe only
  'next-bill-date': 'Next Bill Date (if active)',
  'extend-subscription': 'Extend',
  'switch-to-stripe-subscription': 'Switch to Stripe subscription',
  'approve-subscription': 'Approve',
  'approve-subscription-reason': `You're just one step away! We're redirecting you to PayPal to finalize your subscription setup. Please follow the instructions on PayPal's page to approve your subscription. Your subscription status is currently "Approval Pending," and it will be activated as soon as you complete this step.`,
  'approve-subscription-button': 'Proceed to PayPal',
  'cancel-subscription': 'Cancel',
  'confirm-cancel-subscription':
    'Are you sure you want to cancel the VIP subscription? Your free trial will be terminated if your plan is still during free trial period.',
  'subscription-cancelled':
    'Your membership subscription cancellation request has been received.',
  Subscriptions: 'Subscriptions',
  Approve: 'Approve',
  'use-stripe': 'I want to use Stripe',
  'one-time-payment': 'One time payment',
  'subscription-summary-existing':
    'You already have a subscription that will end on <bold>{{nextBillTime}}</bold> and is set to auto renew via Stripe. Each renewal occurs every <bold>{{cadence}}</bold>, and the renewal fee is <bold>{{price}} HKD</bold>.',
  'subscription-summary-new':
    'After successfully one-time purchasing a <bold>{{extendDuration}}</bold> membership, the new subscription will end on {{nextBillTime}} and auto renew via Stripe. Each renewal occurs <bold>every {{cadence}}</bold>, and the renewal fee is <bold>{{price}} HKD</bold>. The subscription can only be extended to up to 2 years.',
  'manual-summary':
    'Your membership will end on <bold>{{nextBillTime}}</bold>, currently not using subscriptions.',
  'subscription-switch-summary':
    'We will redirect to the Stripe website, where you will be asked to enter your credit card information or set up a Stripe account for Stripe subscription. <bold>There will be no charges for this operation and your remaining membership ({{remainingDays}} days) will be converted to a free trial period</bold>. The first payment will be after <bold>{{nextBillTime}}</bold>. Promo codes cannot be used during the transition operation, but once successfully switched to a Stripe subscription, you will be able to use the "Extend Subscription" feature to extend your subscription, at which time promo codes can be used.',
  'whatsapp-us-if-you-have-any-questions':
    'Chat with us on WhatsApp if you have any questions: <link />',
  'cadence-1month': 'month',
  'cadence-6month': '6 months',
  'cadence-12month': 'year',
  'checking-out':
    'Navigating to the payment site. Please refresh this page when the payment is processed.',
  'click-to-redirect-if-not': "Click here if the payment page doesn't show up.",
  'setting-up-subscription':
    'Navigating to the Stripe website. Please refresh this page when the subscription is set up.',
  // Plan cards
  'plan-basic-title': 'Basic',
  'plan-basic-subtitle': 'Explore DataLouder for free',
  'plan-basic-price': 'Free',
  'plan-pro-title': 'Pro',
  'plan-pro-subtitle':
    'Full function, unlock all indicators and charts, enhance trading performance significantly',
  'plan-pro-1m': 'month',
  'plan-pro-6m': '6 months',
  'plan-pro-12m': 'year',
  'pay-every-1m': 'Monthly',
  'pay-every-6m': 'Semi-annually',
  'pay-every-12m': 'Annually',
  'buy-6m-cheaper': 'SAVE $1,299.95!',
  'buy-1y-cheaper': 'SAVE $3,299.89!',
  'plan-pro-free-trial': 'First 10 days free trial!',
  'each-user-only-one-time-free-trial':
    'Each user can only have a free trial one-time! Previous VIP users will no longer be able to have free trial. Please contact us if any questions.',
  'stripe-checkout-button-text': 'Checkout',
  // Register
  'i-know-and-agree': 'I confirm I read and agree to the',
  and: 'and',
  'register-failed':
    'Registration failed. If you are already our user, please log in or reset your password.',
  'invalid-country-code':
    'Please enter your phone country code e.g. Hong Kong: +852',
  'duplicated-email': 'This email is being used or not a valid email',
  'duplicated-username': 'This username is being used',
  // Home
  'Join Now': 'Join Now',
  // Email Verify Page
  'evp-title': 'Account Verification',
  'evp-body': 'Your account has been verified. Thank you!',
  // Copyright
  'All Rights Reserved.': 'All Rights Reserved.',
  // system status
  Task: 'Task',
  'Current State': 'Current State',
  'Updated At': 'Updated At',
  HKT: 'HKT',
  // table
  'BS-short': 'BS',
  'Gem-short': 'Gem',
  'stock-type-us': '🇺🇸',
  'stock-type-hk': '🇭🇰',
  'stock-type-crypto': 'Crypto', // to support legacy stock type
  'stock-type-crpt': 'Crypto',
  'stock-type-crptbn': 'Crypto',
  'stock-type-otc': 'OTC',
  // ResetpasswordPage
  'Reset Password': 'Reset Password',
  'Send Verification Code': 'Send Verification Code',
  'reset-code-incorrect': 'Verification code is not correct',
  'invalid-phone-num': 'Invalid Phone Number',
  'not-support-country':
    "Your phone's country is not currently supported, please register by email address.",
  'too-many-request': 'Please wait 60 seconds',
  'bad-request': 'Illegal request detected',
  'password-reset-success':
    'Your password has been reset, you need to login again.',
  'Verification Code': 'Verification Code',
  'Verification code is required.': 'Verification code is required.',
  'Re-enter effective phone number or email address':
    'Re-enter effective phone number or email address',
  Submit: 'Submit',
  // loginPage
  'Log in': 'Log in',
  "I don't have an account": "I don't have an account",
  'forget password?': 'forget password?',
  'login-block-warning':
    'Users only have 10 login attempts per hour, if exceeded the account will be temporarily blocked for 1 hour.',
  Remember: 'Remember',
  'Login is required.': 'Login is required.',
  'Password is required.': 'Password is required.',
  // register Page
  'How you want us to call you?': 'How you want us to call you?',
  'Public name will be used in watching list': `This username will be displayed in the users' watching list`,
  'Name is required.': 'Name is required.',
  'Public Name is required': 'Public Username is required.',
  'email-placeholder':
    'Enter email here, we will not disclose your email without your consent.',
  'Please retype your password.': 'Passwords do not match, please retype.',
  'I already have an account': 'I already have an account',
  // stock page
  statistics: 'Statistics',
  'recent-month': 'Past month',
  'expert-views': 'Expert Views',
  strategy: 'Strategy',
  'stock-not-found': 'Sorry the stock is not found in our database.',
  'input-stock-name-or-code': 'Type stock code or name',
  'related-statistics': 'Related Statistics',
  ixic_price_trading_view:
    'Price of IXIC is provided by Trading View temporarily.',
  click_to_view_detail: 'Click to view',
  // stock stragtehy
  n_trades: 'Number of trades',
  win_rate: 'Win rate',
  mean_annual_return: 'Mean annual return',
  max_drawdown_rate: 'Max drawdown',
  calmar_ratio: 'Calmar ratio',
  sharpe_ratio: 'Sharpe ratio',
  sharpe_ratio_SH: 'Strong hold sharpe ratio',
  total_return: 'Total return',
  total_return_SH: 'Strong total return',
  // Admin
  Admin: 'Admin',
  Name: 'Name',
  Users: 'Users',
  'Email Records': 'Email Records',
  'Sent At': 'Sent At',
  Email: 'Email',
  Phone: 'Phone',
  Subject: 'Subject',
  View: 'View',
  'Registered On': 'Registered On',
  register: 'Register',
  subscribe: 'Subscribe',
  'subscribe-member': 'Subscribe',
  'last-used-time': 'Last Used Time',
  ID: 'ID',
  Title: 'Title',
  'Video ID': 'Video ID',
  Edit: 'Edit',
  Add: 'Add',
  Cancel: 'Cancel',
  enabled: 'Enabled',
  'used-time': 'Used count',
  'task-id': 'Task ID',
  'task-name': 'Task Name',
  'job-id': 'Job ID',
  'cron-expression': 'Cron Expression',
  timezone: 'Timezone',
  'targeted-at': 'Target Execution Time',
  status: 'Latest Status',
  params: 'Parameters',
  Tasks: 'Tasks',
  Jobs: 'Jobs',
  'Restart Job': 'Restart Job',
  'Restart Daemon': 'Restart Daemon',
  'Restart Realtime Daemon': 'Restart Realtime Daemon',
  'Restart Backend Daemon': 'Restart Backend Daemon',
  'Restart CMS Daemon': 'Restart CMS (Strapi) Daemon',
  'Restart MySQL Daemon': 'Restart MySQL Daemon',
  Financial: 'Financial',
  PromoCodeUsage: 'Promo Code Usage',
  ManageStockTag: 'Manage Stock Tags',
  UserId: 'User Id',
  PromoCode: 'Promo Code',
  PaidAmount: 'Paid Amount',
  PaidDate: 'Paid Date',
  Audit: 'Audit',
  'monthly-table': 'Monthly Table',
  Month: 'Month',
  Income: 'Income',
  Refund: 'Refund',
  Revenue: 'Revenue',
  // task names
  DailyPrice: 'Update Daily Price',
  CCASS: 'Update CCASS',
  GroupDeviation: 'Group Signals (Deviation)',
  GroupRP180: 'Group Signals (RP180)',
  GroupRP360: 'Group Signals (RP360)',
  Signal: 'Detect Signals',
  GroupNone: 'Group Signals (None)',
  ProbNone: 'Calculate Probabilities (No Group)',
  ProbDev: 'Calculate Probabilities (Dev)',
  ProbRP180: 'Calculate Probabilities (RP180)',
  ProbRP360: 'Calculate Probabilities (RP360)',
  ProbBS: 'Calculate Probabilities (Bluestack)',
  GroupSMA: 'Group Signals (SMA)',
  DayMap: 'Find Day Relations',
  GroupMktcap: 'Group Signals (Mktcap)',
  ProbMktcap: 'Calculate Probabilities (Mktcap)',
  ProbSMA10: 'Calculate Probabilities (SMA10)',
  ProbSMA20: 'Calculate Probabilities (SMA20)',
  ProbSMA50: 'Calculate Probabilities (SMA50)',
  ProbSMA250: 'Calculate Probabilities (SMA250)',
  GroupBB: 'Group Signals (BB)',
  GroupRSI: 'Group Signals (RSI)',
  ProbBB: 'Calculate Probabilities (BB)',
  ProbRSI: 'Calculate Probabilities (RSI)',
  GroupEMA: 'Group Signals (EMA)',
  ProbEMA10: 'Calculate Probabilities (EMA10)',
  ProbEMA20: 'Calculate Probabilities (EMA20)',
  ProbEMA50: 'Calculate Probabilities (EMA50)',
  ProbEMA250: 'Calculate Probabilities (EMA250)',
  MinuteData: 'Update Minute Price Data',
  UsersWinPercentage: 'Users Win Data',
  InfluencersWinPercentage: 'Influencers Win Data',
  ConsituentSMA: 'Consituent SMA',
  DailyPrice_2: 'Index Price Data',
  MarketZones: 'Market Zones Data',
  // histogram
  'yellow-ma': 'Yellow line is 5-day moving average of gain/loss ratio',
  inx: 'S&P 500 Index',
  gspc: 'S&P 500 Index',
  dji: 'Dow Jones Industrial Average',
  hstech: 'HANG SENG TECH INDEX',
  ixic: 'IXIC',
  hsi: 'HANG SENG INDEX',
  bitcoin: 'Bitcoin',
  btc: 'Bitcoin',
  // new badge
  'new-badge': 'New!',
  'new-badge-feature': 'New Feature!',
  'new-badge-content': 'New Content!',
  // fav stock
  'fav-stock': 'My Watch Lists',
  'others-fav-stock': `Other users' Watch Lists`,
  'fav-stock-display': 'Watch Lists Display',
  'show-fav-stock-display': 'Show Watch Lists',
  'hide-fav-stock-display': 'Hide Watch Lists',
  'win-percentage-note':
    'Win rate and return are calculated by data of your bookmarked stock on or after 2021-01-21 (Latest version   release date)',
  'fav-history': 'History',
  'fav-list': 'Watchlist',
  'his-fav-stock': 'His/Her Favorite Stocks',
  'no-fav-stocks': 'You do not have favorite stocks, yet',
  'no-fav-history': 'You do not have history, yet',
  'win-overview': 'Overview',
  'earning-%': 'Return',
  'win-rate': 'Win Rate',
  'win-analyse-HK': 'HK Watching List Performance',
  'win-analyse-US': 'US Watching List Performance',
  'win-analyse-CRPT': 'Crypto Watching List Performance',
  'added-fav-stock-at': 'Added {{deltaTime}}',
  // dashboard
  'Edit Profile': 'Edit Profile',
  'You have been with us for': 'You have been with us for',
  'peek-profile':
    'Here is the peek at your profile information, if they are not up to date, you can update it.',
  // hkex profile
  Industry: 'Industry',
  'Listing Date': 'Listing Date',
  'Financial Year Ends': 'Financial Year Ends',
  Chairman: 'Chairman',
  'Principal Office': 'Principal Office',
  'Place of Incorporation': 'Place of Incorporation',
  'Listing Category': 'Listing Category',
  Registrar: 'Registrar',
  'as at': 'as at',
  'company-intro': 'Company Profile',
  'Shares outstanding': 'Shares outstanding',
  'PE Ratio': 'PE Ratio',
  Beta: 'Beta',
  'Gross Profit': 'Gross Profit',
  'Total Revenue': 'Total Revenue',
  'Net Income': 'Net Income',
  'Current Assets': 'Current Assets',
  'Total Assets': 'Total Assets',
  'Total Liabilities': 'Total Liabilities',
  'Current Cash': 'Current Cash',
  'Current Debt': 'Current Debt',
  'Total Cash': 'Total Cash',
  'Total Debt': 'Total Debt',
  'Cash Flow': 'Cash Flow',
  // hkex news
  'company-news': 'Recent News',
  'release-time': 'Release Time',
  content: 'Content',
  'scanned-every-hour': 'Updated every hour',
  'scanned-5-min': 'Updated every 5 mins',
  'load-more': 'Load More',
  // public profile
  'no-permission-to-view': "Sorry, you don't have enough permission to view it",
  // configure profile permission
  'public-profile-permission': 'Profile Permissions',
  'permission-private': 'Private',
  'permission-public': 'Visible to other members',
  'your-permission-url-is': 'Your profile page link is',
  'public-alias': 'Public Name',
  'duplicate-name-alert': 'This name is registered',
  'empty-name-alert': 'Please enter your public name',
  // color style
  'color-style': 'Theme color setting',
  'graph-color-style': 'Candlestick color',
  'nop-color-style': 'CCASS+ (NOP) color',
  'ccass-title': 'CCASS+',
  ccass: 'CCASS+',
  'concentration-color-style': 'Concentration color',
  'comparison-color-style': 'Comparison color',
  'graph-up': 'Up',
  'graph-down': 'Down',
  // strategy setting
  'strategy setting': 'Strategy Setting',
  'backtest-mode': 'Backtest Mode',
  'simple-mode': 'Simple Mode',
  'mode-selection': 'Mode Selection',
  'backtest-mode-info':
    'Backtest Mode : The price viewer will show details including strategy return and forward test date',
  'simple-mode-info':
    'Simple Mode : Displaying strategies for the best user experience',
  // free user
  'purchase-vip-to-unlock-all': 'Purchase Membership to Unlock All Features',
  'feature-requires-vip': 'This Feature is not Available for Free Users',
  'you-need-to-pay-to-unlock':
    'You need DataLouder membership to unlock the feature ',
  Purchase: 'Purchase',
  DEMO: 'DEMO',
  'and-enable-realtime-view': ' (including realtime statistics)',
  'know-more': 'Know more',
  'register-to-see-more': 'Become a free member to see more information',
  // feature name
  'feature-ratio': 'View Past Gain vs Loss Chart',
  'feature-bubble': 'View Bubble Chart',
  'feature-date-navigator': 'View Past Statistics',
  'feature-PriceViewer': 'Price Viewer',
  'feature-VIPTradeIdeas': 'VIP Trade Ideas',
  'feature-Zone': 'Market Zone Data',
  'feature-CCASSTable': 'CCASS+ Summary Viewer',
  'feature-HKEXNewsViewer': 'HKEX News Viewer',
  'feature-private-stocklist': 'Favorite Stocks Privacy Settings',
  'feature-stocklist': "View Other Users' Favorite Stocks",
  'buy-vip': 'Buy VIP',
  // user stock list
  'usl-stock-view-user-title': 'Users who liked this stock',
  'usl-stock-view-nouserlike-title': 'No users like this stock',
  'usl-member': 'Member',
  'usl-free': 'Free User',
  'usl-select': 'Sharing Views',
  'usl-you-are-viewing': "You are viewing <u>{{name}}</u>'s favorite stocks",
  'usl-go-back': 'Go back to original stock list',
  'usl-explain':
    "Members can opt-in to make their stock list public. <br />Free users' stock list will always be public.",
  'usl-explain1': 'Select a user to view his/her favorite stocks',
  'more-like': 'There are {{n}} anonymous users who like this stock.',
  'more-unlike': 'There are {{n}} anonymous users who dislike this stock.',
  'usl-not-found': `We can't find this user`,
  // error handling
  oops: 'Oops, something is wrong!',
  'issue-reported':
    'The issue has been reported to us, if you have any questions, contact our support with issue ID and QR code <b>{{eventId}}</b>. Sorry for any inconvenience.',
  'your-browser-is-too-old':
    'We apologize for the inconvenience, but it seems that your current browser version is not compatible with our web application, which has led to an unexpected issue. To ensure the best and most secure experience, we kindly ask that you upgrade your browser to the latest version or consider using a different browser that is up to date.',
  // shortkeys
  Shortkeys: 'Shortcuts (?)',
  'Shortkeys-modal': 'Shortcuts Available Here',
  'shortkey-section-global': 'Global shortcuts',
  'go-to-lookup': 'Open Lookup',
  'go-to-ccass': 'Open CCASS+',
  'go-to-signal': 'Open Signals',
  'go-to-ranking': 'Open Statistics',
  'show-help-buttons': 'Show help buttons',
  'view-shortkeys': 'View shortcuts',
  'shortkey-section-table': 'Stock table shortcuts',
  'previous-stock': 'Go to previous stock',
  'previous-stock-5': 'Jump previous 5 stocks',
  'next-stock': 'Go to next stock',
  'next-stock-5': 'Jump next 5 stocks',
  'shortkey-section-peek': 'Stock shortcuts',
  'add-remove-favorite': 'Add/Remove current stock from my favorite list',
  'add-remove-isUnlike': 'Add/Remove current stock from my unlike list',
  'shortkey-section-admin': 'Admin shortcuts',
  'toggle-payment-view': 'Toggle Payment UI',
  // notification
  'notification-center': 'Notification Center',
  'notification-popup-checkbox': `Don't pop up this window`,
  'post-category-release': 'Release Note',
  'post-category-tutorial': 'Tutorial',
  'post-category-news': 'News',
  Unreleased: 'Unreleased',
  Empty: 'Empty',
  Unread: 'Unread',
  // Tutorials
  'videos-and-tutorial': 'Tutorials',
  tutorial: 'Tutorials',
  tutorials: 'Tutorials',
  Tutorials: 'Tutorials',
  Videos: 'Videos',
  'show-question-buttons': 'Show hint buttons',
  'hide-question-buttons': 'Hide hint buttons',
  'more-tutorials': 'More tutorials',
  'course-menu': 'Course',
  'free-seminars': 'Free Seminars',
  course: 'Course(Jan)',
  'trading-course': 'Trading Course',
  'advanced-course': 'Advanced Class',
  // Tips
  'local-time': 'Local Time',
  'tips-create': 'Create Record',
  'tips-submit': 'Submit',
  'tips-reset': 'Reset',
  'create-tips-modal-title': 'Create tips record',
  'edit-tips-modal-title': 'Edit tips record',
  influencer: 'Influencer',
  'influencer-rank': 'Rank',
  'influencer-score': 'Influencer Score',
  'influencer-result': 'Influencer Result',
  'influencer-count': 'Sample Size',
  'stock-code': 'Stock Code',
  direction: 'Direction',
  'tips-date': 'Date (GMT +8)',
  'created-at': 'Created at (GMT +8)',
  'created-by': 'Created by',
  'tips-status': 'Status',
  'edit-tips-button': 'Edit',
  'doubt-tips-button': 'Doubt',
  'tips-verify': 'Verify',
  'verify-tips-button': 'Verify',
  'delete-tips-button': 'Delete',
  'tips-price': 'Tips Price',
  'key-comment': 'key Comment',
  channel: 'Channel',
  'source-link': 'Source Link',
  'tips-return': 'Average Return',
  'tips-return-till-now': 'Return (till now)',
  'tips-win-analyse-hk': 'HK Tips Performance',
  'tips-win-analyse-us': 'US Tips Performance',
  'tips-history': 'Historical prediction',
  'stock-no-tips-history':
    'This stock has no prediction made by any influencer',
  'no-tips-history-hk':
    'This influencer has not made any prediction in the hk market',
  'no-tips-history-us':
    'This influencer has not made any prediction in the us market',
  'tips-win-percentage-note':
    'Tips performance is reflecting the average win rate and return rate of an influencer who had at least made 7 records only. US and Cryptos are combined for now.',
  'tips-bullish': 'Bullish',
  'tips-bearish': 'Bearish',
  'tips-error': 'Error:',
  'tips-error-required': 'Error: Required -',
  'tips-choose-influencer-from-list':
    'Select from suggest or type a new name if you cannot find.',
  'tips-choose-stockCode-from-list':
    'Select stockCode from suggestion dropdown only',
  'tips-choose-direction': 'Choose either one direction',
  'tips-obtain-price':
    'Select stockCode from suggestion dropdown only to obtain price',
  'tips-no-future-date': 'Cannot input future date!',
  'tips-insert-channel': 'Fill in source platform name',
  'tips-insert-link': 'Fill in source link',
  'tips-insert-keyword': 'Fill in key comments',
  'tips-create-tips-principle':
    "Note: We recommend only to create a tips record when an influencer's recommendation have clear message on long or short",
  'tips-status-V': 'Verified',
  'tips-status-A': 'Verified (Bot)',
  'tips-status-Q': 'Questionable (Bot)',
  'tips-status-D': 'Doubted',
  'tips-status-X': 'Inaccurate',
  'tips-status-default': 'Submitted',
  // RangeSlider
  'close-popup': 'Hide',
  // global Alerts
  UserTokenInvalid: 'The credential is not valid, please log in again.',
  BadGateway:
    'DataLouder is working on updating its components, ' +
    'and it usually only takes around 10 seconds. ' +
    'If you constantly experience this please contact us.',
  // user configurable alarms
  Alarms: 'Alarms',
  'New Alarm': 'New Alarm',
  GE: 'Reach',
  LE: 'Under',
  create: 'Create',
  comparisonStock: 'Compare Stock',
  // General error
  'unknown-error': 'Unknown error',
  invalidDate: 'Invalid date',
  // SEO title and description
  'seo-title-Home': '股市數據回測平台｜大數據監察股市 讓交易更有把握',
  'seo-title-Signals': '獨家風險訊號功能｜避開突如其來股災',
  'seo-title-Ranking': '全功能排行榜｜輕鬆選出倍升股',
  'seo-title-Tips': '監察股市專家｜真假財演一眼睇穿',
  'seo-title-Lookup': '大戶散戶盤路｜助你發掘翌日爆升機會',
  'seo-title-CCASS': '獨家 CCASS+｜監察貨源集中程度及監察大戶/散戶倉位',
  'seo-description-Home':
    'DataLouder為股票交易者提供專業財經資訊，運用大數據對市場資訊進行分析，為用戶增加交易分析優勢。以客觀數據代替主觀判斷，提升投資回報及交易表現。',
  'seo-description-Signals':
    '獨家訊號回測功能，一鍵回測常見圖表形態，直接分析升跌機率。獨家原創「四色八線圖」助股民更容易解讀大市風險，避開危機。',
  'seo-description-Ranking':
    '想要尋找強勢股，卻不知道從何入手嗎？排行榜為你一秒搜羅港股美股強弱股。',
  'seo-description-Tips':
    '以大數據分方式記錄財經機構及專家對股市的看法，以直觀圖表自動計算準勝度、回報率，細緻呈現專家表現。',
  'seo-description-Lookup':
    '即日統計全日盤路，分析大戶散戶買賣盤，助你捉緊大戶步伐，快人一預先部署。',
  'seo-description-CCASS':
    '多角度審視貨源集中程度及監察大戶/散戶倉位，全面透視各間證券行持貨比例。',
  // Help
  'articles-in-same-category': 'Topics in the same category',
  Help: 'Resources',
  // 3rd party login
  'continue-with-fb': 'Continue with Facebook',
  'continue-with-google': 'Continue with Google',
  'retry-login': 'Try other ways to log in',
  // fb login
  'fb-error-user_denied': 'Authorization denied',
  // whatsapp channel
  'trading-squad': 'Trading Squad',
  'trading-squad-setting': 'Trading Squad Setting',
  'click-to-trading-squad-setting': "Press Here to 'Trading Squad' Settings",
  'members-only': 'VIP Members Only',
  'see-the-market-trend-in-10-mins': 'See the market trend in 10 mins',
  'whatsapp-channel-description':
    '10-min reading to understand the market trend by instant Datalouder analysis, in order to find the trading edge in the volatile market.',
  'whatsapp-channel-status': 'status',
  processing: 'Processing',
  deleted: 'Deleted',
  problem: 'Problem',
  joined: 'Joined',
  unconnected: 'Unconnected',
  'questions-contact-us': 'Contact Us',
  'join-now': 'Join Now',
  'join-whatsapp-channel': 'Join Whatsapp Channel',
  'update-whatsapp-number': 'Update',
  'enter-whatsapp-number': 'Please Input the WhatsApp Number',
  please: 'Please ',
  confirm: 'Confirm',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  input: 'Input',
  ok: 'OK?',
  end: 'End',
  'home-page': 'Home',
  'whatsapp-channel-register': 'Register',
  'whatsapp-channel-register-sm': 'Register',
  'whatsapp-number': 'the WhatsApp Number',
  'received-request': 'Received the Request',
  'received-update-request': 'Received the Update Request',
  'congratulation-text':
    '<span>Please pay attention on WhatsApp</span><br/><span>You will be added to the ‘Trading</span><br/><span>Squad’ within 3 working days.</span>',
  'whatsapp-faq-title-1':
    'Can I join the WhatsApp channel without subscribing to the plan?',
  'whatsapp-faq-title-2': 'What is it about?',
  'whatsapp-faq-title-3': 'Is it suitable for the trading beginner?',
  'whatsapp-faq-title-4': 'Who should join the `Trading Squad`?',
  'whatsapp-faq-title-5': 'What is the flow to join the Trading Squad?',
  'whatsapp-faq-title-6': 'Technical Support and Customer Service',
  'whatsapp-faq-description-1':
    'We are sorry that you cannot join the WhatsApp Channel without subscribing to the plan.<br/>Our product aim to merge the content of ‘Trading Squad’, data in our website, and your own strategy to make your personal rational analysis and trading idea.<br/>Join Member: <a href="https://datalouder.com/payment" target="_blank">Click here</a>',
  'whatsapp-faq-description-2':
    '<ul class="info"> <li>Daily Datalouder System Analysis: capture the trend within 10 minutes</li> <li>Newest Website Features Announcement: faster and more accurate analysis on data, catch the trading opportunity, and minimize the risk.</li> <li>News: Will not miss a single news about trading</li></ul>',
  'whatsapp-faq-description-3':
    '<ul class="info"> <li>Yes, it suits everyone, including beginners. You can learn and receive most updated and valuable market news to facilitate your trading journey.</li></ul>',
  'whatsapp-faq-description-4':
    '<ul class="info"><li>Someone who believes in data and rational analysis</li><li>Someone who wants cutting-edge news</li><li>Someone who wants to correct the bad trading habits and mindset</li><li>Someone who wants to discover the next 10x return opportunity</li></ul>',
  'whatsapp-faq-description-5':
    '<ol class="info"><li>Input your WhatsApp mobile number.</li><li>Confirm it</li><li>We will process your request within 3 working days.</li><li>Done!</li></ol>',
  'whatsapp-faq-description-6':
    '<ul class="info"><li>If you encounter technical issues or other inquiries, please contact us: <a href="https://api.whatsapp.com/send?phone=85269000755" target="_blank">+852 69000755 </a></li></ul>',
  // whatsapp channel admin page
  'expire-at': 'expire at',
  request: 'Request',
  'new-request': 'New Request',
  'update-request': 'Update',
  'remind-request': 'Remind',
  'delete-request': 'delete',
  'done-false': 'Complete',
  'done-true': 'Incomplete',
  remark: 'Remark',
  'staff-remark': 'Staff Remark',
  update_time: 'Update Time',
  'create time': 'Create Time',
};
